import { Component, OnInit } from '@angular/core';
import { StageService } from '../services/stage-modal.service';
import { CoreService, HttpService } from '../../../../services';
import { Select } from '../../../../models';
import { ModeEffectif, Option, SelectionMode } from '../../../../models/effectif/option.model';
import { EffectifsService } from '../../../../effectif/effectifs.service';

@Component({
  selector: 'queoval-stage-vue360',
  templateUrl: './vue360.component.html',
  styleUrls: ['./vue360.component.css']
})

export class Vue360Component implements OnInit {
  public OptionFormateur: Option;
  public OptionClient: Option;
  public OptionContact: Option;
  public stagiaireService: EffectifsService;
  public clientService: EffectifsService;
  constructor(
    public service: StageService,
  ) { }

  private ChartListForStage: Array<Select> = [
    { id: "FACTURATION_STAGE", value: "Facturation HT" },
    { id: "PLANNING_STAGE", value: "Planning heures" },
    { id: "DEPENSES_STAGE", value: "Dépenses HT" },
    { id: "PRESENCES_STAGE", value: "Présences" },
  ];
  private ChartListForCursus: Array<Select> = [
    { id: "FACTURATION_CURSUS", value: "Facturation HT" },
    { id: "PLANNING_CURSUS", value: "Planning" },
    { id: "DEPENSES_CURSUS", value: "Dépenses HT" },
    { id: "PRESENCES_CURSUS", value: "Présences" },
  ];
  public ChartListToUse: Array<Select>;
  public mobile: boolean;
  private stagiaireServiceInit: boolean = false;
  private clientServiceInit: boolean = false;

  public ngOnInit(): void {

    this.mobile = window.innerWidth < 768;
    this.Init(this.service.isModeCursus.value);
    this.service.isModeCursus.subscribe((result: boolean) => {
      this.Init(result);
    });

    this.OptionFormateur = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.FORMATEURMAIL, "", SelectionMode.NONE, SelectionMode.NONE)
    this.OptionClient = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.CLIENTMAIL, "", SelectionMode.NONE, SelectionMode.NONE)
    this.OptionContact = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.STAGIAIREMAIL, "", SelectionMode.NONE, SelectionMode.NONE)
  }

  private Init(isModeCursus: boolean): void {
    if (this.stagiaireService) {
      this.stagiaireServiceInit = true;
      this.stagiaireService.EffectifModel.IsAffectedToCycles = isModeCursus;
      this.stagiaireService.loadData();
    }
    if (this.clientService) {
      this.clientServiceInit = true;
      this.clientService.EffectifModel.IsAffectedToCycles = isModeCursus;
      this.clientService.loadData();
    }
    if (isModeCursus) {
      this.ChartListToUse = this.ChartListForCursus;
    } else {
      this.ChartListToUse = this.ChartListForStage;
    }
  }

  public setService(service: string, output: EffectifsService) {
    if (service == 'client') {
      this.clientService = output;
    } else
      if (service == 'stagiaire') {
        this.stagiaireService = output;
      }
    if (this.stagiaireService && !this.stagiaireServiceInit && this.clientService && !this.clientServiceInit)
      this.Init(this.service.isModeCursus.value);
  }

}
